export default function isDefaultLocale(locale) {
    var _a, _b;
    return locale.toLowerCase() === ((_b = (_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.locale) === null || _b === void 0 ? void 0 : _b.toLowerCase());
}
export var SUPPORTED_LOCALES = ['en-US', 'fr-CA', 'ja-JP'];
export var DEFAULT_LOCALE = 'en-US';
export var extractLocale = function (url, queryParams) {
    var _a;
    var urlLocale = (_a = url.split('/')[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    var locale = SUPPORTED_LOCALES.find(function (locale) { return locale.toLowerCase() === (urlLocale === null || urlLocale === void 0 ? void 0 : urlLocale.toLowerCase()); });
    if (locale)
        return locale.toLowerCase();
    var langParam = new URLSearchParams(queryParams).get('locale');
    if (langParam)
        return langParam;
    return DEFAULT_LOCALE.toLowerCase();
};
